import React from "react";
import Entry from './components/Entry';
import EntryConfig from './components/entryconfigType';
import './Default.css';


export const menuItems: EntryConfig[] = [
  {
    img:"/icons/map-location-dot-solid.svg",
    img_alt: "map",
    link: "/map",
    text: "mapa"
  },
  {
    img:"/icons/location-dot-solid.svg",
    img_alt: "places",
    link: "/places",
    text: "miejsca"
  },
  {
    img:"/icons/briefcase-solid.svg",
    img_alt: "useful",
    link: "/przydasie",
    text: "przydasie"
  },
  {
    img:"/icons/poland.svg",
    img_alt: "poland",
    link: "/poland",
    text: "Poland"
  },
  {
    img:"/icons/hands-praying-solid.svg",
    img_alt: "sdm",
    link: "/sdm",
    text: "ŚDM"
  },
  {
    img:"/icons/campground-solid.svg",
    img_alt: "zhr",
    link: "/zhr",
    text: "ZHR"
  },
]



function Menu() {
  return (
    <>
      <div className="page-title" style={{ fontSize: '80px' }}>
        Home
      </div>
      <div className="navigation-wraper">
        <nav className="navigation-bar">
          {menuItems.map((v,i) => <Entry conf={v} key={`nav-${i}`}/>)}
        </nav>
      </div>
    </>
  );
}

export default Menu;
